import type { WhitelabelVariantDefinition } from '../../types';

export const pblcrEstWhitelabel = {
  id: 'pblcrEst',
  colors: {
    primary: {
      900: '#002962',
      800: '#003A8C',
      700: '#096DD9',
      500: '#48ACFF',
      300: '#91D5FF',
      100: '#E6F7FF',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const pblcrEstDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: pblcrEstWhitelabel.colors.primary[900],
      dark: pblcrEstWhitelabel.colors.primary[800],
      main: pblcrEstWhitelabel.colors.primary[700],
      light: pblcrEstWhitelabel.colors.primary[500],
      lighter: pblcrEstWhitelabel.colors.primary[300],
      muted: pblcrEstWhitelabel.colors.primary[100],
      contrastText: pblcrEstWhitelabel.colors.primary.contrastText,
    },
  },
  typography: { fontFamily: 'Montserrat' },
};
